export const API = {
  login: "/accounts/api/v1/api/token/",
  refresh: "/accounts/api/v1/api/token/refresh/",
  me: "/accounts/api/v1/me/",
  users: "/accounts/api/v1/users/",
  availableSlots: "/operations/api/v1/student-registrations/available-slots/",
  teacherWorkingDays: "/institutes/api/v1/teacher-working-days/",
  studentOperations: "/operations/api/v1/student-operations/",
  teacherAttendanceLog: "/operations/api/v1/student-operations/teacher-log/",
  // Accounting routes
  revenueOverview: "/accounting/api/v1/revenue/overview/",
  expenses: "/accounting/api/v1/expenses/",
  expenseCategories: "/accounting/api/v1/expense-categories/",
  teacherSettlements: "/accounting/api/v1/teacher-settlements/",
  teacherSettlementSummary: "/accounting/api/v1/teacher-settlement-summary/summary/",
  teacherSettlementSummaryMonthly: "/accounting/api/v1/teacher-settlement-summary/summary-monthly/",
  teacherSettlementTransactions: "/accounting/api/v1/teacher-settlement-summary/transactions/",
  teacherInstituteSalaries: "/accounting/api/v1/teacher-institute-salaries/",
  cashboxReconciliations: "/accounting/api/v1/cashbox-reconciliations/",
  bankReconciliations: "/accounting/api/v1/bank-reconciliations/",
  receivablesSummary: "/accounting/api/v1/receivables/summary/",
  receivablesLedger: "/accounting/api/v1/receivables/ledger/",
  operationBrowser: "/accounting/api/v1/operations/",
  // Notes routes
  personalNotes: "/notes/api/v1/personal-notes/",
  colleagueNotes: "/notes/api/v1/colleague-notes/",
  colleagueNoteReplies: "/notes/api/v1/colleague-note-replies/",
  supportQuestions: "/notes/api/v1/support-questions/",
  // AI support chat
  aiConversations: "/ai/api/v1/conversations/",
  aiStaffConversations: "/ai/api/v1/staff/conversations/",
  // Assistant: daily briefing (manager) + role-scoped chat; attendance writes only via confirm/cancel
  assistantActions: "/assistant/api/v1/actions/",
  assistantStatus: "/assistant/api/v1/status/",
  assistantBriefing: "/assistant/api/v1/briefing/",
  assistantOverview: "/assistant/api/v1/overview/",
  assistantConversations: "/assistant/api/v1/conversations/",
  assistantTranscribe: "/assistant/api/v1/transcribe/",
  // Statistics routes
  systemStatistics: "/operations/api/v1/statistics/system-statistics/",
  quickSystemStatistics: "/operations/api/v1/statistics/quick-system-statistics/",
  classroomInfoGraph: "/operations/api/v1/statistics/classroom-info-graph/",
  enhancedSystemStatistics: "/operations/api/v1/statistics/enhanced-system-statistics/",
  enhancedClassroomInfoGraph: "/operations/api/v1/statistics/enhanced-classroom-info-graph/",
  peakHours: "/operations/api/v1/statistics/peak-hours/",
  busyDays: "/operations/api/v1/statistics/busy-days/",
  seasonalTrends: "/operations/api/v1/statistics/seasonal-trends/",
  // Advanced Financial Analytics routes
  revenueTrends: "/accounting/api/v1/statistics/revenue-trends/",
  expenseBreakdown: "/accounting/api/v1/statistics/expense-breakdown/",
  revenueForecast: "/accounting/api/v1/statistics/revenue-forecast/",
  courseProfitability: "/accounting/api/v1/statistics/course-profitability/",
};
